import React from 'react';
import useDecisionTreeRunContext from '../DecisionTreeRunContext/useDecisionTreeRunContext';
import useNodeHistory from './Hooks/useNodeHistory';
import { DecisionTreeInfoContext } from './useDecisionTreeInfoContext';

export default function DecisionTreeInfoContextProvider({ children }: { children: React.ReactNode }) {
  const { run } = useDecisionTreeRunContext();
  const value = useNodeHistory(run);

  return (
    <DecisionTreeInfoContext.Provider value={value}>
      {children}
    </DecisionTreeInfoContext.Provider>
  );
}
